import {Nullable} from "../../models/common/Nullable";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {Observable, of} from "rxjs";
import {ofType, StateObservable} from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {catchError, map, mergeMap, switchMap} from "rxjs/operators";
import {ajax} from "rxjs/ajax";
import {eventNotificationError} from "../common/EventNotificationActions";
import {OutgoingInvoiceModule} from "../../models/accounting/AccountBook";
import {OutgoingInvoiceProjectTaskItem} from "../../models/accounting/OutgoingInvoiceProjectTaskItem";
import {ProjectId} from "../../models/projects/Project";
import {Identifier} from "../../models/common/Identifier";


/** backend api path */
function apiPath( id: Nullable< number > = null ): string {
    const uri = 'invoices/outgoing/items/flat';
    if( id === null ) {
        return APP_CONFIG.baseWeb + uri;
    } else {
        return APP_CONFIG.baseWeb + uri  + id;
    }
}


/** union of all Bill related action types */
export type OutgoingInvoiceProjectTaskFlatItemViewActionTypes = FetchOutInvoiceProjectTaskFlatItemActionTypes



/**
 * fetch list of bills action types
 */
export interface FetchOutInvoiceProjectTaskFlatItemAction extends ProjectId, ReduxAction< typeof FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM > {
    stageIds: Identifier<number>[]
    projectBillType: string
}
export interface FetchOutInvoiceProjectTaskFlatItemSuccessAction extends ReduxAction<typeof FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_SUCCESS > {
    payload: OutgoingInvoiceProjectTaskItem[]

}
export interface FetchOutInvoiceProjectTaskFlatItemErrorAction extends  ErrorAction< typeof FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_ERROR >{}

export type FetchOutInvoiceProjectTaskFlatItemActionTypes = FetchOutInvoiceProjectTaskFlatItemAction
    | FetchOutInvoiceProjectTaskFlatItemSuccessAction
    | FetchOutInvoiceProjectTaskFlatItemErrorAction
/**
 * redux action constants
 */
export const FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM = "FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM";
export const FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_SUCCESS = "FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_SUCCESS";
export const FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_ERROR = "FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_ERROR";

/**
 * redux action functions
 */
export function fetchOutInvoiceProjectTaskFlatItem(
    projectId: Identifier<number>,
    stageIds: Identifier<number>[],
    projectBillType: string
) : FetchOutInvoiceProjectTaskFlatItemAction {
    return { type: FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM, projectId, stageIds, projectBillType };
}
export function fetchOutInvoiceProjectTaskFlatItemSuccess( payload: OutgoingInvoiceProjectTaskItem[] ) : FetchOutInvoiceProjectTaskFlatItemSuccessAction {
    return { type: FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_SUCCESS, payload };
}
export function fetchOutInvoiceProjectTaskFlatItemError( error: Error ): FetchOutInvoiceProjectTaskFlatItemErrorAction {
    return { type: FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM_ERROR, error };
}

/**
 * redux observable to fetch bills from api
 */
export function fetchOutInvoiceProjectTaskFlatItemEpic(
    action$: Observable< FetchOutInvoiceProjectTaskFlatItemAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType( FETCH_OUT_INVOICES_PROJECT_TASK_FLAT_ITEM ),
        mergeMap(action => {
            const stageIdParam = action.stageIds.map( _stageId => "stageIds="+_stageId.rawValue ).join("&");
            const path = `${ apiPath() }/projects/${ action.projectId.rawValue }?${ stageIdParam }&invoiceItemType=${ action.projectBillType }`;

            return ajax(
                APP_CONFIG.getRequestObject( path )
            ).pipe(
                map(response => {
                    return fetchOutInvoiceProjectTaskFlatItemSuccess(
                        response.response as OutgoingInvoiceProjectTaskItem[]
                    )
                }),
                catchError(error => of(
                    fetchOutInvoiceProjectTaskFlatItemError( error),
                    eventNotificationError(error, store$, OutgoingInvoiceModule.identifier, "fetchOutInvoiceProjectTaskFlatItem")
                ))
            );

        })
    );
}